
<router-outlet *ngIf="!isIframe"></router-outlet>